/**
 * This file was auto generated from scripts/generate-version.sh
 */
export const VERSION: string = '0.8.3'
